import { useState } from 'react';
import ChatService from '../services/chat-service';
import usePolling from './use-polling';

const POLL_MS = 60000;

const chatService = new ChatService();

const fetchUnreadCount = async () => {
  const chatSummaryList = await chatService.listChatSummary();

  return chatSummaryList.reduce((sum, chat) => sum + (chat.unreadMessageCount || 0), 0);
};

const useUnreadMessages = () => {
  const [totalUnreadCount, setTotalUnreadCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);

  // A failed poll keeps the last count on the badge rather than hiding it until the next success.
  const poll = () => fetchUnreadCount().catch(error => {
    console.error('Error fetching unread messages:', error);
    setLoading(false);
    throw error;
  });

  usePolling(poll, POLL_MS, {
    shareKey: 'chat-summary',
    onData: total => {
      setTotalUnreadCount(total);
      setLoading(false);
    },
  });

  return { totalUnreadCount, loading };
};

export default useUnreadMessages;
